import { useQuery } from '@tanstack/react-query';
import getSSOConfig from '@/API/SSO/getSSOConfig';

const useGetSSOConfig = (currentCompany, { enabled = true } = {}) => {
    return useQuery({
        queryKey: ['ssoConfig', currentCompany],
        queryFn: () => getSSOConfig(currentCompany),
        enabled: enabled && !!currentCompany,
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
    });
};

export default useGetSSOConfig;
